import React, { useEffect, useState } from "react";
import { gql, useLazyQuery } from "@apollo/client";
import { Skeleton, Drawer, Space, Badge } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import OtherErrors from "@general/otherErrors";
import moment from "moment-jalaali";
import CoreServicesTable from "./table";
import TableFilters from "@general/tableFilters";
import getWindowSize from "@utils/windowSize";
import WorkSpaceDetails from "./formDtails/workSpaceForm";
import MeetingRoomDetails from "./formDtails/meetingRoomForm";
import ClassDetails from "./formDtails/classFrom";
import EventDetails from "./formDtails/eventForm";
import ConsultationDetails from "./formDtails/consultation";

const GETPRODUCTS = gql`
  query ($paginateInput: PaginateInput!, $searchInput: ProductSearchInput!) {
    getProductsCount(searchInput: $searchInput)
    getProducts(paginateInput: $paginateInput, searchInput: $searchInput) {
      id
      createdAt
      updatedAt
      name
      description
      category
    }
  }
`;

function AdminCoreServices(props) {
  const [tableData, setTableData] = useState({});
  const [currentPage, setCurrentPage] = useState();
  const [sortDir, setSortDir] = useState("desc");
  const [sortColumn, setSortColumn] = useState("createdAt");
  const [filterDateFrom, setFilterDateFrom] = useState(null);
  const [filterDateTo, setFilterDateTo] = useState(null);
  const [filterSearchPhrase, setFilterSearchPhrase] = useState("");
  const [drawer, setDrawer] = useState(false);

  const windowSize = getWindowSize().innerWidth;

  const [getProducts, products] = useLazyQuery(GETPRODUCTS, {
    fetchPolicy: "no-cache",
    onCompleted(data) {
      setTableData(data);
    },
  });

  useEffect(() => {
    getProducts({
      variables: {
        paginateInput: {
          page: currentPage,
          perPage: 10,
          sort: sortColumn && sortColumn,
          sortDir: sortDir,
        },
        searchInput: {
          createdAt:
            filterDateFrom && filterDateTo
              ? [filterDateFrom, filterDateTo]
              : null,
          textSearch: filterSearchPhrase,
        },
      },
    });
  }, [currentPage, sortDir, filterDateTo, filterSearchPhrase]);

  const dataUpdated = () => {
    getProducts({
      variables: {
        paginateInput: {
          page: currentPage,
          perPage: 10,
          sort: sortColumn && sortColumn,
          sortDir: sortDir,
        },
        searchInput: {},
      },
    });
  };

  const pageChange = (current) => {
    setCurrentPage(current);
  };

  const sort = (sortData) => {
    setCurrentPage(1);
    setSortColumn(sortData.columnKey);
    if (sortData.order === "ascend") setSortDir("asc");
    if (!sortData.order || sortData.order === "descend") setSortDir("desc");
  };

  const filterDate = (dates, dateString) => {
    setCurrentPage(1);
    if (dateString[0] === "" || dateString[1] === "") {
      setFilterDateFrom(null);
      setFilterDateTo(null);
    } else {
      setFilterDateFrom(
        moment(dateString[0], "jYYYY/jMM/jDD")
          .startOf("day")
          .toDate()
          .toISOString()
      );
      setFilterDateTo(
        moment(dateString[1], "jYYYY/jMM/jDD")
          .endOf("day")
          .toDate()
          .toISOString()
      );
    }
  };

  const filterSearch = (phrase) => {
    setCurrentPage(1);
    setFilterSearchPhrase(phrase);
  };

  const openDrawer = (id, category) => {
    setDrawer({ id, category });
  };
  const closeDrawer = () => {
    setDrawer(false);
  };

  const { category: cat, id } = drawer;

  if (products.error) return <OtherErrors />;
  if (Object.keys(tableData).length === 0)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );
  return (
    <Badge.Ribbon
      style={{
        left: "-32px",
        height: "40px",
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
      }}
      text={
        <Link to="/core-services/add-service">
          <span style={{ padding: "10px", color: "white" }}>
            <PlusCircleOutlined /> سرویس جدید
          </span>
        </Link>
      }
    >
      <>
        <Drawer
          title="جزییات سرویس"
          placement="right"
          open={drawer}
          onClose={closeDrawer}
          size={windowSize >= 750 ? "large" : null}
          width={windowSize < 750 ? windowSize - 50 : null}
        >
          {cat === "WORK_SPACE" ? (
            <WorkSpaceDetails id={id} onDataUpdate={dataUpdated} />
          ) : cat === "MEETING_ROOM" ? (
            <MeetingRoomDetails id={id} onDataUpdate={dataUpdated} />
          ) : cat === "CLASS" ? (
            <ClassDetails id={id} onDataUpdate={dataUpdated} />
          ) : cat === "EVENT" ? (
            <EventDetails id={id} onDataUpdate={dataUpdated} />
          ) : cat === "CONSULTATION" ? (
            <ConsultationDetails id={id} onDataUpdate={dataUpdated} />
          ) : null}
        </Drawer>

        <TableFilters onFilterDate={filterDate} onFilterSearch={filterSearch} />
        <Space></Space>
        <br />
        <CoreServicesTable
          onDataUpdate={dataUpdated}
          data={tableData}
          onSort={sort}
          onPageChange={pageChange}
          currentPage={currentPage}
          loading={products.loading}
          onOpenDrawer={openDrawer}
        />
      </>
    </Badge.Ribbon>
  );
}

export default AdminCoreServices;
